export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7699.c9b1e2bb.jpg";